<template>
  <InputWrapper
    class="select-field-wrapper"
    :shrink-label="!!model"
    :errors="errors"
    :focused="isFocused"
  >
    <template #label>{{ label }}</template>
    <div class="select-field">
      <select
        :id="id"
        ref="selectTag"
        v-model="model"
        class="select-field__select"
        :data-qa="dataQa"
        v-bind="$attrs"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="handleChange"
        @click="handleClick"
      >
        <option
          v-for="({ text, attrs }, index) in options"
          :key="index"
          class="select-field__select--option"
          v-bind="attrs"
        >
          {{ text }}
        </option>
      </select>
      <ArrowDownIcon class="select-field__activator-icon" />
    </div>
  </InputWrapper>
</template>

<script setup>
import { ref } from 'vue'
import ArrowDownIcon from '@shared/assets/icon/ArrowDownIcon.vue'
import InputWrapper from './InputWrapper.vue'

defineOptions({
  inheritAttrs: false,
})

const emit = defineEmits(['blur', 'focus', 'change', 'click'])
defineProps({
  errors: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: '',
  },
  /**
    Options: { text: string, selectedText: string, value: any }[]
  */
  options: {
    type: Array,
    default: () => [],
  },
  id: {
    type: String,
    default: '',
  },
  dataQa: {
    type: String,
    default: '',
  },
})

const selectTag = ref(null)
const model = defineModel({ default: '', type: String })

const isFocused = ref(false)

const handleFocus = () => {
  isFocused.value = true
  emit('focus')
}

const handleBlur = () => {
  isFocused.value = false
  emit('blur')
}

const handleChange = () => {
  emit('change')
}

const handleClick = () => {
  emit('click')
}
</script>

<style lang="scss" scoped>
.select-field-wrapper :deep(.wrapper__container) {
  @include grid-container(1fr);
}

.select-field {
  width: 100%;
}

.select-field__select {
  @include kds-typography-interactive-medium;

  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  width: 100%;
  // this equals to padding-top of 24px, line-height of 22px, font-size
  // of 16px and padding-bottom of 8px
  // but when clicking on the top padding the cursor is set to the
  // right position in the text field instead of to the start
  line-height: 4.375rem;
  padding: 0;
  margin-bottom: -1rem;

  color: $kds-color-text-primary;
  border-radius: 4px;
  border: none;
  outline: none;
  box-sizing: border-box;
  height: 100%;
}

.select-field__activator-icon {
  position: absolute;
  right: 0;
  top: 45%;
}
</style>
